// extracted by mini-css-extract-plugin
export default {"type_card__wrapper":"style_type_card__wrapper__J8zZO","type_card__icon":"style_type_card__icon__PNStl","type_card__title":"style_type_card__title__US3fI"};